<template>
  <div class="standalone-auth">
    <div class="standalone-auth__card">
      <LogoTile :src="logoUrl" :alt="tenantName" :size="48" />
      <v-icon color="warning" size="32">block</v-icon>
      <p class="standalone-auth__message">Your account is not part of {{ tenantName }}.</p>
      <v-btn color="primary" variant="outlined" @click="session.signOut()">Sign out</v-btn>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useTheme } from "vuetify";
import { useSessionStore } from "@/stores/session";
import LogoTile from "@/shell/LogoTile.vue";

export default defineComponent({
  name: "NoAccess",
  components: { LogoTile },
  setup() {
    const session = useSessionStore();
    const theme = useTheme();
    const tenantName = computed(() => session.tenant?.name || "MetaShip");
    const logoUrl = computed(() => {
      const branding = session.tenant?.branding;
      return (theme.global.current.value.dark ? branding?.logoDarkUrl : branding?.logoLightUrl) || null;
    });
    return { session, tenantName, logoUrl };
  },
});
</script>

<style scoped>
.standalone-auth {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.standalone-auth__card {
  width: 100%;
  max-width: 340px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  text-align: center;
}
.standalone-auth__message {
  font-size: 14px;
  margin: 0;
}
</style>
